module.exports = __webpack_public_path__ + "static/media/synth_03.668b871e.mp3";